import {
  STICKY_BANNER_RULE_TYPES,
  BEHAVIOR_MODES,
  SCROLL_RESOLUTION,
  STICKY_PAGE_TYPES,
  STICKY_BANNER_EVENT_TYPES
} from "./stickyBannerConfig.types";
import { mergeStickyBannerConfig } from "./commonConfig";

/**
 * Standard Reports route — milestone scroll (top / middle / bottom) × score band matrix.
 * Copy lives in `common/stickyBannerMessages.js` + matrix; this file is triggers + wiring only.
 */
export const reportsPageStickyBannerConfig = mergeStickyBannerConfig({
  id: "reports-page",
  pageType: STICKY_PAGE_TYPES.REPORT,
  stickyBannerEventType: STICKY_BANNER_EVENT_TYPES.GENERIC_REPORT,
  behaviorMode: BEHAVIOR_MODES.SCROLL,
  scrollResolution: SCROLL_RESOLUTION.MILESTONE,

  messageRules: [],
  scrollTriggers: [],

  /** Middle: IO on this section OR scroll-ratio fallback (see useStickyBannerMilestonePhase). */
  middleMilestoneTargetId: "tte-report-section-breakdown",
  middleScrollEnterRatio: 0.35,
  middleScrollExitRatio: 0.3,
  /** Bottom milestone enter (scroll % of document); exit uses scrollMilestones row below. */
  bottomThreshold: 0.82,

  /**
   * order 2 = middle milestone (section-wise), order 3 = bottom (near end).
   * Phase 1 (top) has no entry — implied default scroll position.
   */
  scrollMilestones: [
    {
      id: "section-breakdown",
      order: 2,
      type: STICKY_BANNER_RULE_TYPES.SCROLL_ELEMENT,
      targetElementId: "tte-report-section-breakdown",
      threshold: 0.05,
      rootMargin: "0px 0px -12% 0px"
    },
    {
      id: "page-bottom",
      order: 3,
      type: STICKY_BANNER_RULE_TYPES.SCROLL_PERCENT,
      enterRatio: 0.82,
      exitRatio: 0.77
    }
  ]
});
